import ACTION_TYPES from "../types";

const initialState = {
  clipboardDataWithFormating: null,
  footer: null,
};

const rowCopyPasteReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.SET_COPIED_ROWS:
      return {
        ...state,
        clipboardDataWithFormating: action.payload.clipboardDataWithFormating,
        footer: action.payload.footer
      }

    case ACTION_TYPES.CLEAR_COPIED_ROWS:
      return initialState;

    default:
      return state;
  }
};

export default rowCopyPasteReducer;
